import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function isUserExists(userId: string) {
  const docSnap = await db.getDoc(db.doc(firestore, 'users', userId));
  return docSnap.exists();
}

export async function isUserPrivateExists(userId: string) {
  const docSnap = await db.getDoc(db.doc(firestore, 'users', userId, 'private', userId));
  return docSnap.exists();
}

export async function isUsernameAvailable(username: string) {
  const q = db.query(db.collection(firestore, 'users'), db.where('username', '==', username));
  const querySnapshot = await db.getDocs(q);
  return querySnapshot.empty;
}
